import type { ReactNode } from 'react';
import { MultiTariffUpsaleRadioType } from 'reactApp/sections/QuotaLanding/multiTariffUpsaleDialog/models/MultiTariffUpsaleDialog.model.types';
import { MultiTariffUpsaleModelBase } from 'reactApp/sections/QuotaLanding/multiTariffUpsaleDialog/models/MultiTariffUpsaleDialogBase.model';
import { getPrice } from 'reactApp/ui/TariffSectionNew/helpers/getPrice';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';
import { getFirstSomePeriodsAsWord, getPeriodName } from 'reactApp/utils/Period';
import { capitalizeFirstLetter } from 'reactApp/utils/string';

export class MultiTariffUpsaleModel extends MultiTariffUpsaleModelBase {
    override getTitle(): ReactNode {
        return 'Платить за\u00A0год выгоднее';
    }

    override getTitleDescription(): ReactNode {
        return `Вы\u00A0выбрали тариф ${this.product.space.value} на\u00A0месяц\u00A0— а\u00A0если взять на\u00A0год, то\u00A0можно сэкономить`;
    }

    override getPriorityCardTopTitle(): ReactNode {
        return 'На\u00A0год';
    }

    override getPriorityCardTitle(): ReactNode {
        const product = this.getUpsaleProduct();
        if (product) {
            const [_, __, ___, productMonthPriceAsText] = getPrice({ product, periodDivider: 'в', locale: 'ru' });
            return productMonthPriceAsText;
        }

        return '';
    }

    override getPriorityCardDescription(): ReactNode {
        const upsaleProduct = this.getUpsaleProduct();
        if (upsaleProduct) {
            if (upsaleProduct.hasTrial) {
                return `${capitalizeFirstLetter(getFirstSomePeriodsAsWord(1, 'm'))} за\u00A01\u00A0₽`;
            }
            return `При покупке на\u00A0${getPeriodName(upsaleProduct.period)}`;
        }

        return '';
    }

    override getPriorityCardLabelText(): ReactNode {
        const upsaleProduct = this.getUpsaleProduct();
        if (upsaleProduct) {
            return this.getMonthToYearEconomyString(upsaleProduct);
        }
    }

    override getSecondaryCardTitle(): ReactNode {
        const product = this.product;

        if (!product) {
            return '';
        }

        const [priceAsText] = getPrice({ product, periodDivider: 'в', locale: 'ru' });
        return priceAsText;
    }

    override getSecondaryCardDescription(): ReactNode {
        const product = this.product;

        if (product && product.discountPrice) {
            return `${capitalizeFirstLetter(
                getFirstSomePeriodsAsWord(product.discountPeriodCount || 1, this.isMonthActivePeriod() ? 'm' : 'y')
            )} по ${product.discountPrice} ₽`;
        }

        return '';
    }

    override getSecondaryCardTopTitle(): ReactNode {
        return 'На\u00A0месяц';
    }

    override getSecondaryCardLabelVisible(): boolean {
        return false;
    }

    override getDwh(selected: MultiTariffUpsaleRadioType) {
        const dwh = super.getDwh(selected);
        const isPriority = selected === MultiTariffUpsaleRadioType.priority;
        return {
            ...dwh,
            name: 'tariff_line',
            selectedPeriod: isPriority ? 'year' : 'month',
            selected_tariff_line: this.activeTab === ETabsName.advanced ? 'advanced' : 'basic',
        };
    }
}
